import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Rom\xE2n\u0103",
  code: "ro",
  messages: {
    alert: {
      close: "\xCEnchide"
    },
    authForm: {
      hidePassword: "Ascunde parola",
      showPassword: "Arat\u0103 parola",
      submit: "Continu\u0103"
    },
    banner: {
      close: "\xCEnchide"
    },
    calendar: {
      nextMonth: "Luna urm\u0103toare",
      nextYear: "Anul urm\u0103tor",
      prevMonth: "Luna precedent\u0103",
      prevYear: "Anul precedent"
    },
    carousel: {
      dots: "Alege\u021Bi diapozitivul de afi\u0219at",
      goto: "Mergi la diapozitivul {slide}",
      next: "Urm\u0103tor",
      prev: "Anterior"
    },
    chatPrompt: {
      placeholder: "Scrie\u021Bi mesajul dvs. aici..."
    },
    chatPromptSubmit: {
      label: "Trimite"
    },
    colorMode: {
      dark: "\xCEntunecat",
      light: "Luminos",
      switchToDark: "Comut\u0103 la modul \xEEntunecat",
      switchToLight: "Comut\u0103 la modul luminos",
      system: "Sistem"
    },
    commandPalette: {
      back: "\xCEnapoi",
      close: "\xCEnchide",
      noData: "Nu exist\u0103 date",
      noMatch: "Nu exist\u0103 date corespunz\u0103toare",
      placeholder: "Tasteaz\u0103 o comand\u0103 sau caut\u0103..."
    },
    contentSearch: {
      links: "Linkuri",
      theme: "Tem\u0103"
    },
    contentSearchButton: {
      label: "Caut\u0103..."
    },
    contentToc: {
      title: "Pe aceast\u0103 pagin\u0103"
    },
    dashboardSearch: {
      theme: "Tem\u0103"
    },
    dashboardSearchButton: {
      label: "Caut\u0103..."
    },
    dashboardSidebarCollapse: {
      collapse: "Restr\xE2nge bara lateral\u0103",
      expand: "Extinde bara lateral\u0103"
    },
    dashboardSidebarToggle: {
      close: "\xCEnchide bara lateral\u0103",
      open: "Deschide bara lateral\u0103"
    },
    error: {
      clear: "\xCEnapoi la pagina principal\u0103"
    },
    fileUpload: {
      removeFile: "Elimin\u0103 {filename}"
    },
    header: {
      close: "\xCEnchide meniul",
      open: "Deschide meniul"
    },
    inputMenu: {
      create: 'Creeaz\u0103 "{label}"',
      noData: "Nu exist\u0103 date",
      noMatch: "Nu exist\u0103 date corespunz\u0103toare"
    },
    inputNumber: {
      decrement: "Scade",
      increment: "Cre\u0219te"
    },
    modal: {
      close: "\xCEnchide"
    },
    pricingTable: {
      caption: "Comparare pre\u021Buri"
    },
    prose: {
      codeCollapse: {
        closeText: "Restr\xE2nge",
        name: "cod",
        openText: "Extinde"
      },
      collapsible: {
        closeText: "Ascunde",
        name: "propriet\u0103\u021Bi",
        openText: "Afi\u0219eaz\u0103"
      },
      pre: {
        copy: "Copiaz\u0103 codul \xEEn clipboard"
      }
    },
    selectMenu: {
      create: 'Creeaz\u0103 "{label}"',
      noData: "Nu exist\u0103 date",
      noMatch: "Nu exist\u0103 date corespunz\u0103toare",
      search: "Caut\u0103..."
    },
    slideover: {
      close: "\xCEnchide"
    },
    table: {
      noData: "Nu exist\u0103 date"
    },
    toast: {
      close: "\xCEnchide"
    }
  }
});
